// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__Ut-YA","title":"AfterFrontImage_title__16mZK"};